module.exports = __webpack_public_path__ + "img/ahorcadoNuevo1.5361373b.png";